export class Role {
	readonly id: number;
	name: string;

	constructor(
		options: {
			id?: number;
			name?: string;
		} = {}
	) {
		this.id = options.id || 4;
		this.name = options.name || 'INTERVENANT';
	}
}
